
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/[path]",
      function () {
        return require("private-next-pages/search/[path].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search/[path]"])
      });
    }
  